class CartDrawerBasicProgressBar extends HTMLElement {
  constructor() {
    super();
    this.threshold = parseFloat(this.getAttribute('threshold')) || 50;
    this.cartTotal = parseFloat(this.getAttribute('cart-total')) || 0;
    this.clubProductInCart = this.getAttribute('club-product-in-cart') || false;
    this.clubProductsInCartCount = parseInt(this.getAttribute('club-product-in-cart-count')) || 0;
  }

  connectedCallback() {
    this.updateProgressBar();

    this.cartUpdateEnrichedUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdateEnriched, (event) => {
      this.clubProductInCart = event.data.isClubProductInCart;
      this.cartTotal = event.data.cart.total_price / 100;
      this.clubProductsInCartCount = event.data.clubProductsInCartCount;
      this.updateProgressBar();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateEnrichedUnsubscriber) {
      this.cartUpdateEnrichedUnsubscriber();
    }
  }

  updateProgressBar() {
    let remainingAmount = 0;
    let progressPercentage = 0;
    if (this.clubProductInCart) {
      this.threshold = 4;
      this.cartTotal = this.clubProductsInCartCount;
      remainingAmount = this.threshold - this.cartTotal;
      progressPercentage = (this.cartTotal / this.threshold) * 100;
    } else {
      remainingAmount = this.threshold - this.cartTotal;
      progressPercentage = (this.cartTotal / this.threshold) * 100;
    }

    const progressBarFill = this.querySelector('.progress-bar-fill');
    const progressText = this.querySelector('.progress-text');

    if (progressBarFill && progressText) {
      if (this.cartTotal >= this.threshold) {
        progressBarFill.style.width = '100%';
        if (this.clubProductInCart) {
          progressText.innerHTML = 'Members pricing & FREE shipping unlocked!';
        } else {
          progressText.innerHTML = 'Free Shipping Unlocked!';
        }
      } else {
        if (this.clubProductInCart) {
          progressText.innerHTML = `Add <span class="remaining-amount"></span> more 6-packs to unlock your members pricing & FREE Continental shipping`;
        } else {
          progressText.innerHTML = `Only <span class="remaining-amount"></span> USD away from free shipping!`;
        }

        // Re-select the remainingAmountSpan after updating innerHTML
        const remainingAmountSpan = progressText.querySelector('.remaining-amount');
        if (remainingAmountSpan) {
          if (this.clubProductInCart) {
            remainingAmountSpan.innerText = remainingAmount;
          } else {
            remainingAmountSpan.innerText = `$${remainingAmount.toFixed(2)}`;
          }
        }

        progressBarFill.style.width = `${progressPercentage}%`;
      }
    }
  }
}

customElements.define('cart-drawer-basic-progress-bar', CartDrawerBasicProgressBar);
